import { GetUserClaimsType } from "../../types/Claim";
import { get } from "../../utils/axios-config";
import { GET_USER_CLAIMS } from "../../utils/constants";

export const getUserClaims = async (userId: string) => await get<GetUserClaimsType[]>(`${GET_USER_CLAIMS}?UserId=${userId}`);
